import get from 'lodash/get';

import { WallpaperAPI } from '../api/wallpaper';
import { optimizePath } from '../../helpers/optimize-path';
import { wallpaperFormat } from '../../helpers/wallpaper-format';

export const DemoProvider = {
  get name() {
    return 'DEMO_PROVIDER';
  },

  isRotationEnabled() {
    return true;
  },

  rotationInterval(config) {
    return config.defaultRotationInterval;
  },

  test(config, state) {
    const advertId = get(state, 'route.params.advert_id', false);
    return advertId !== false;
  },

  async nextCreative(config, { route }) {
    const advertId = route.params.advert_id;

    const response = await WallpaperAPI.load(null, {
      pathExtValues: {
        advertId,
      },
    });

    return this.parseResponse(config, response);
  },

  parseResponse(config, response) {
    const { href, src } = response.body;

    return {
      src: optimizePath({ src: `${config.host}${src}` }),
      format: wallpaperFormat(src),
      meta: {
        href,
      },
    };
  },
};
